import { useIntl } from 'react-intl';

export interface ImageProps {
  src: string;
  height?: string;
  width?: string;
  className?: string;
  alt: string;
  translatedAlt?: boolean;
  style?: React.CSSProperties;
}

export const Image = (props: ImageProps) => {
  const intl = useIntl();
  return (
    <img
      {...props}
      src={`/assets/images/${props.src}`}
      loading="lazy"
      role={props.alt ? 'img' : 'presentation'}
      alt={props.translatedAlt ? intl.formatMessage({ id: props.alt }) : props.alt}
    />
  );
};
